export default __webpack_public_path__ + "static/media/schedule.6f293a02.jpg";